module.exports = __webpack_public_path__ + "static/media/Increased.77718813.png";